import React from 'react';
import { Link } from 'react-router-dom';
import { ENTREPRISE } from '../data/site';
import Bande from './Bande';

// Bloc de rappel a l'action, place apres chaque section qui explique quelque chose.
export default function AppelAction({
  titre = 'Dites-nous ce que vous avez à faire',
  texte = "Le type de chantier, les dates, la largeur de votre accès. On vous répond en quelques heures avec la machine qui convient et son tarif.",
  variante = 'clair',
}) {
  const sombre = variante === 'sombre';
  return (
    <section className={sombre ? 'bg-nuit' : 'bg-trame'}>
      <Bande hauteur={5} />
      <div className="conteneur py-12 sm:py-14">
        <div className="flex flex-col lg:flex-row lg:items-center gap-7 lg:gap-10">
          <div className="lg:flex-1">
            <h3 className={`font-display uppercase text-[24px] sm:text-[30px] leading-[1.06] ${sombre ? 'text-white' : 'text-nuit'}`}>
              {titre}
            </h3>
            <p className={`mt-3 max-w-xl ${sombre ? 'text-white/70' : 'text-nuit/70'}`}>{texte}</p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 shrink-0">
            <Link to="/contact" className="btn-jaune">Demander mon devis</Link>
            <a href={ENTREPRISE.telephoneLien} className={sombre ? 'btn-contour' : 'btn-ligne'}>
              {ENTREPRISE.telephone}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
